<template>
  <div class="teamRYtable" v-loading="loadingTrue">
    <el-table
      :data="tableData"
      :header-cell-style="setColumnDataColor"
      :cell-style="setCellStyle"
      style="width: 100%"
      v-if="!loadingTrue"
    >
      <template slot="empty">
        <img src="@/static/img/cailiao.png" alt style="margin-bottom:10px;line-height:0px;margin-top:50px;width:100px"/>
        <p class="noText" style="color:#666666;fontSize:16px;line-height:30px;margin-bottom:50px">暂无数据</p>
      </template>
      <el-table-column  label="个人图片"  width="150">
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.avatarAddress"
            style="width: 50px; height: 40px;margin-top:5px;"
            :src="scope.row.avatarAddress.split(',')[0]"
            :preview-src-list="scope.row.avatarAddress.split(',')"
            fit="cover"
          ></el-image>
          <el-image
            v-else
            style="width: 50px; height: 40px;margin-top:5px;"
            :src="url"
            :preview-src-list="getUrl"
            fit="cover"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column  label="姓名" prop="name" show-overflow-tooltip width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.name|formatContactName }}</span>
        </template>
      </el-table-column>
      <el-table-column  label="职位" prop="position" show-overflow-tooltip width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.position?scope.row.position:'/' }}</span>
        </template>
      </el-table-column>
      <el-table-column  label="工种" prop="workType" show-overflow-tooltip width="150"></el-table-column>
      <el-table-column label="年龄" prop="age" width="148">
        <template slot-scope="scope">
          <span>{{ scope.row.age?scope.row.age:'/' }}</span>
        </template>
      </el-table-column>
      <el-table-column  label="联系电话" prop="contactPhone" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.contactPhone ? starPhone(scope.row.contactPhone) : '/' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="民族" prop="nationName" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.nationName?scope.row.nationName:'/' }}</span>
        </template>
      </el-table-column>
      <el-table-column  label="籍贯" show-overflow-tooltip prop="address" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.address?scope.row.address:'/' }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column  label="操作" width="100">
        <template slot-scope="scope">
          <el-button type="text" @click="$refs.memberDetailModal.open(scope.row.no)">查看详情</el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <Pagination :param="param" @change="getTeamMembers" v-if="tableData.length!=0" :loadingTrue="loadingTrue"></Pagination>

    <MemberDetailModal ref="memberDetailModal" />
  </div>
</template>

<script>
import { setColumnDataColor, setCellStyle } from '@/views/Home/components/style.js'
import { apiTeamDetail } from '@/api/apiTeamDetail'
import url from "@/assets/gerendianpuNew.png";
export default {
  data () {
    return {
      url:url,
      getUrl:[url],
      setColumnDataColor,
      setCellStyle,
      loadingTrue: false,
      tableData: [],
      param: {
        page: 1,
        limit: 20,
        teamNo: '',
        companyNo: '',
        userNo: '',
        total: 0,
        type: 0
      }
    }
  },

  components: {
    Pagination: () => import('@/views/Construction/components/Pagination'), // 分页
    MemberDetailModal:()=>import('./MemberDetailModal'), // 团队人员详情弹窗
  },
  created () {
    this.getTeamMembers()
  },
  methods: {
    async getTeamMembers () {
      this.loadingTrue = true
      if (this.$route.query.teamNo) this.param.teamNo = this.$route.query.teamNo
      // if(this.$route.query.companyNo) this.param.companyNo = this.$route.query.companyNo;
      let res = await apiTeamDetail.getTeamMembers(this.param)
      if (res.data.code === 200) {
        this.tableData = res.data.data.records
        this.param.total = res.data.data.total
        this.loadingTrue = false
      } else {
        this.loadingTrue = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-table__empty-text{
  line-height: 0px;

}
/deep/.cell{
  padding: 0 20px !important;
}
/deep/td{
  height: 44px !important;
}
/deep/th{
  height: 44px !important;
  padding: 10px 0 !important;
}
</style>
